import React from 'react';
import useImageSizes from '@loomstateorg/shared-frontend/hooks/useImageSizes';
import { Reference } from 'types/reference';
import Image, { NextFrontasticImage } from 'frontastic/lib/image';
import { Link, Typography } from '@loomstateorg/shared-frontend';

export interface Props {
  tile: {
    title: string;
    image: NextFrontasticImage;
    target?: Reference;
    children?: React.ReactNode;
  };
  labelClassName?: string;
  index?: number;
}

const Tile: React.FC<Props> = ({
  tile,
  labelClassName = 'mt-5 block overflow-hidden truncate rounded-b-sm border-neutral-300 py-5 text-primary-regular md:text-16 lg:mt-0 lg:border lg:bg-white lg:py-10',
  index = 0,
}) => {
  const tileImageSizes = useImageSizes({ md: 0.5, lg: 0.25, defaultSize: 0.25 });

  return (
    <Link link={tile.target} className="block shrink-0 grow basis-0" data-testid={`category-tile-${index}`}>
      <div className="relative" style={{ paddingBottom: '122%' }}>
        <Image
          {...tile.image}
          sizes={tileImageSizes}
          alt={tile.title}
          fill={true}
          style={{ objectFit: 'cover' }}
          className="brightness-75"
          loading="eager"
        />
      </div>
      <Typography
        as="h2"
        fontSize={14}
        align="center"
        fontFamily="libre"
        className={labelClassName}
        data-testid={`category-tile-title-${index}`}
      >
        {tile.title}
      </Typography>
    </Link>
  );
};

export default Tile;
